import React, { useEffect, useState } from 'react';
import { Menu, X, MessageSquare } from 'lucide-react';
import './Header.css';
import agentAvatar from '../../assets/images/user-avatar.png';

const Header = ({ totalCount, onLogoClick, onContactClick }) => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 0);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`header ${scrolled ? 'is-scrolled' : ''}`}>
      <div className="header-container">
        <div 
          className="header-logo-section" 
          onClick={() => {
            onLogoClick?.();
            setMobileMenuOpen(false);
          }} 
          role="button"
          tabIndex={0}
        >
          <img src={agentAvatar} alt="Hasan Korkmaz" className="agent-avatar" />
          <div className="agent-details">
            <span className="agent-name">Hasan Korkmaz</span>
            <span className="agent-office">RE/MAX West</span>
          </div>
        </div>

        <div className="header-nav-section">
          <nav className="desktop-nav">
            <button className="nav-btn" onClick={() => onLogoClick?.()}>Ana sayfa</button>
            <button className="nav-btn">Hakkında</button>
            <a
              href="https://remaxwestgayrimenkul.sahibinden.com/emlak?sorting=storeShowcase&userId=a1vTMw-NBI5dzdzBpzSz07w"
              className="nav-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              Sahibinden
            </a>
            <a
              href="https://www.remax.com.tr/danisman/40174/hasan-korkmaz"
              className="nav-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              Remax
            </a>
          </nav>

          {totalCount > 0 && <div className="header-badge">Toplam {totalCount} İlan</div>}

          <button 
            className="mobile-contact-btn"
            onClick={onContactClick}
            aria-label="İletişim"
          >
            <MessageSquare size={18} />
            <span>İletişim</span>
          </button>

          <button 
            className="mobile-menu-toggle"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Menüyü Aç/Kapat"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu Dropdown */}
      {mobileMenuOpen && (
        <div className="mobile-nav-dropdown">
          <button className="mobile-nav-btn active" onClick={() => { onLogoClick?.(); setMobileMenuOpen(false); }}>Ana sayfa</button>
          <button className="mobile-nav-btn">Hakkında</button>
          <a
            href="https://remaxwestgayrimenkul.sahibinden.com/emlak?sorting=storeShowcase&userId=a1vTMw-NBI5dzdzBpzSz07w"
            className="mobile-nav-btn"
            target="_blank"
            rel="noopener noreferrer"
          >
            Sahibinden
          </a>
          <a
            href="https://www.remax.com.tr/danisman/40174/hasan-korkmaz"
            className="mobile-nav-btn"
            target="_blank"
            rel="noopener noreferrer"
          >
            Remax
          </a>
        </div>
      )}
    </header>
  );
};

export default Header;